<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-number
  [class]="parentClass"
  [name]="sectionTagName + '.' + field.FieldName" nz-input [(ngModel)]="recordProperty.ValueAsObject"
    [ngModelOptions]="{ updateOn: 'blur' }" (ngModelChange)="valueChanged()" [nzDisabled]="recordProperty.ReadOnly"
    [nzParser]="numberParser" [nzFormatter]="formatterNumber" [nzMax]="recordProperty.MaxValue"
    [nzMin]="recordProperty.MinValue" nz-tooltip [nzTooltipTitle]="
      recordProperty.MinValue !== undefined ||
      recordProperty.MaxValue !== undefined
        ? tooltip
        : undefined
    ">
  </nz-input-number>
  <ng-template #tooltip>
    <span *ngIf="recordProperty.MinValue !== undefined">
      {{ "Min. " | locale }} {{ recordProperty.MinValue }}
    </span>
    <span *ngIf="recordProperty.MaxValue !== undefined">
      <nz-divider *ngIf="recordProperty.MinValue !== undefined"></nz-divider>
      {{ "Max. " | locale }} {{ recordProperty.MaxValue }}
    </span>
  </ng-template>
</nz-form-control>
